import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faLoader } from "@fortawesome/pro-regular-svg-icons";

import { cn } from "../generic/shadcn-utils";

function Spinner(
  props: React.PropsWithChildren<{
    className?: string;
  }>,
) {
  return (
    <div role="status" className="flex flex-col items-center justify-center">
      <FontAwesomeIcon
        icon={faLoader}
        className={cn(
          "size-3 cursor-pointer text-light animate-spin",
          props.className,
        )}
      />
    </div>
  );
}

export default Spinner;
